import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import IssuesList from '../serviceDesk/IssueList'
import RequestTypeList from '../serviceDesk/request/RequestTypeList'
import { selectADUserInfo } from '../auth/reducer'
import { selectAppList } from '../appStatus/reducer'
import { Container, PageTitle, PageHeader, H3, InfoTooltip } from '../components/index'
import RefreshIcon from '@atlaskit/icon/glyph/refresh'
import AccessStatus from '../accessSelfService/AccessStatus'
import CheckAccessStatus from '../accessSelfService/CheckAccessStatus2'
import AppStatus from '../appStatus/AppStatus'
import { getUserAccessStatus } from '../accessSelfService/actions'
import { selectIsRequestPending } from '../util/index'

export class HomePage extends Component {  

  render () {
    let {
      appList,
      adUserInfo,
      getAccessPending,
      } = this.props
    let jiraStatus
    if (appList) {
      jiraStatus = appList.find(app => {return app.name.toLowerCase()==='jira'})
    }
    return (
      <div>
        <PageTitle title='Home' />
        <PageHeader title='Build And Agile Tools Self-Service Portal' />
        <Container section >
                <H3 className='pb5-sm'>App Access</H3>
                  <CheckAccessStatus />
        </Container>
        {
          !appList || !jiraStatus.available ? null : 
          <Container section>
	     <h3>Average Wait Time</h3>
	     <p>Application access is generally available within two (2) hours of the initial request. Please <a href="https://baat.niketech.com/create" target="_blank">create a request</a> if you're still unable to access the application(s) after that time.</p> 
          </Container>
        }
      </div>
    )
  }
}

export default withRouter(connect((state) => {
    return {
        getAccessPending: selectIsRequestPending(state, getUserAccessStatus),
        adUserInfo: selectADUserInfo(state),        
        appList: selectAppList(state)
    }
},{getUserAccessStatus})(HomePage))



// WEBPACK FOOTER //
// ./client/src/home/HomePage.js